package fr.frux.shared.dto

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
enum class SiteAccessRuleDto { OPEN, ASK, PRIVATE }

@Serializable
enum class PlantingCountDto { ONE, FEW, SOME, MANY }

@Serializable
data class SitePlantingDto(
    val id: Long,
    val species: SpeciesRefDto,
    val countEstimate: PlantingCountDto,
    val note: String? = null,
)

@Serializable
data class SiteDto(
    val id: Long,
    val name: String,
    val description: String? = null,
    val latitude: Double,
    val longitude: Double,
    val accessRule: SiteAccessRuleDto = SiteAccessRuleDto.OPEN,
    val managerName: String? = null,
    val ownerUserId: Long? = null,
    val ownerUsername: String? = null,
    val plantings: List<SitePlantingDto> = emptyList(),
    val treesCount: Int = 0,
    val trees: List<TreeDto>? = null,
    val createdBy: Long,
    val createdByUsername: String? = null,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val createdAt: Instant? = null,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val updatedAt: Instant? = null,
    val isFavorite: Boolean = false,
    val isOwner: Boolean = false,
    val canClaim: Boolean = false,
    val canDelete: Boolean = false,
    val reportedByMe: Boolean = false,
    // Prochaine récolte du lieu (#617), pour l'afficher sur la fiche sans second appel.
    // Nul par défaut = rétro-compatible.
    val nextHarvest: SiteHarvestSummaryDto? = null,
    // Liens de l'appelant avec le jardin (ADR 0037) et présence d'un gestionnaire actif. Additifs.
    val myRoles: List<SiteMembershipDto> = emptyList(),
    val hasManager: Boolean = false,
)

/** Résumé de la prochaine récolte d'un lieu (#617), le strict nécessaire pour la bannière de la fiche. */
@Serializable
data class SiteHarvestSummaryDto(
    val id: Long,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val scheduledDate: Instant,
    val status: HarvestStatus,
    val hostedByOwner: Boolean,
)

@Serializable
data class CreatePlantingRequest(
    val speciesId: Long,
    val countEstimate: PlantingCountDto,
    val note: String? = null,
)

@Serializable
data class CreateSiteRequest(
    val name: String,
    val latitude: Double,
    val longitude: Double,
    val description: String? = null,
    val accessRule: SiteAccessRuleDto = SiteAccessRuleDto.OPEN,
    val managerName: String? = null,
    val claimOwnership: Boolean = false,
    val plantings: List<CreatePlantingRequest> = emptyList(),
)

@Serializable
data class UpdateSiteRequest(
    val name: String? = null,
    val description: String? = null,
    val accessRule: SiteAccessRuleDto? = null,
    val managerName: String? = null,
)

@Serializable
data class CreateSiteReportRequest(
    val kind: String,
    val details: String? = null,
)

@Serializable
data class SiteListResponse(
    val sites: List<SiteDto>,
    val count: Int,
    val total: Int? = null,
)
